// src/RootRedirect.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RootRedirect = () => {
  const { session, role, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (!session) {
      navigate('/login');
      return;
    }

    if (!role) {
      return;
    }

    switch (role) {
      case 'super_admin':
        navigate('/admin-dashboard');
        break;
      case 'client_admin':
        navigate('/application-dashboard');
        break;
      case 'viewer':
        navigate('/application-dashboard');
        break;
      default:
        navigate('/not-authorized');
    }
  }, [session, role, loading, navigate]);

  return null;
};

export default RootRedirect;
